import { ref } from "vue"
import _signupStepsCommonProps from "../../foundation/js/configurations/_signupStepsCommonProps"
import SignupStepActions from "../../../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepActions/SignupStepActions.vue"
import Tooltip from "../Tooltip/Tooltip.vue"

export default {
  name: "ContactStepCategoryContent",
  props: _signupStepsCommonProps,
  components: {
    SignupStepActions,
    Tooltip,
  },
  setup(props) {
    const categories = ref(props.currentStepOptions)
    const categoryInput = ref(props.getNamedFieldInputData.category);

    return {
      categories,
      categoryInput
    }
  },
}
